export default (theme) => {
  return `
    .mu-badge{
      background-color: ${theme.track};
      color: ${theme.text.alternate};
    }
  `;
};



// WEBPACK FOOTER //
// ./src/muse-ui/Badge/theme.js